module.exports = __webpack_public_path__ + "img/celts-barbarian.5957070f.png";